import React from 'react';
import { Box } from '@chakra-ui/react';
import AppBar from './AppBar';
function Layout({ children }) {
  return (
    <>
      <Box minH='100vh'>
        <AppBar />
        <Box
          pt='10vh'
          d='flex'
          justifyContent='center'
          alignItems='center'
          bg='#fcfcfc'
          width='100%'
        >
          {children}
        </Box>
      </Box>
    </>
  );
}

export default Layout;
